import { menuState } from 'js/main';

export default function (menuState) {
	const trigger = document.getElementById('js-search-trigger');
	const triggerTarget = document.getElementById('js-search-trigger-target');
	const header = document.getElementById('header');
	const breakpoint = 900;

	// Debugging
	if (menuState.debug) console.log(menuState);

	if (!trigger || !triggerTarget || !header) return;

	const closeMenu = () => {
		if (trigger.classList.contains('--is-active')) {
			if (menuState.debug) console.log('Closing the search menu');
			trigger.classList.remove('--is-active');
			trigger.setAttribute('aria-expanded', 'false');
			triggerTarget.classList.remove('--is-opened');
			header.classList.remove('--is-alternate');
		}
	};

	const toggleClasses = () => {
		if (menuState.openMenu && menuState.openMenu !== 'search') {
			menuState.closeCurrentMenu();
		}

		menuState.openMenu = triggerTarget.classList.contains('--is-opened') ? null : 'search';
		menuState.closeCurrentMenu = closeMenu;

		if (menuState.debug) console.log('Toggling search menu visibility');

		const isOpened = trigger.classList.toggle('--is-active');
		trigger.setAttribute('aria-expanded', isOpened.toString());
		triggerTarget.classList.toggle('--is-opened');

		if (window.innerWidth < breakpoint) {
			header.classList.toggle('--is-alternate');
		}

		if (isOpened) {
			const firstFocusable = triggerTarget.querySelector('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
			if (firstFocusable) firstFocusable.focus();
		}
	};

	trigger.addEventListener('click', toggleClasses);
}
